export default "__VITE_ASSET__CIORLaK9__"